import ajax from "@/lib/ajax/index";
import { uniqueId } from "@/views/zhiji/js/common/util.js";
import { MessageBox } from "element-ui";

// 添加画像标签分类
export async function addTagClass(reqData, gameId) {
    const params = {
        game_id: gameId,
        name: reqData.name,
        describe: reqData.describe,
        type: reqData.type,
        use_type: reqData.useType.join()
    };
    const res = await ajax.post("/xiaoyue-operation/user_profile/tag_classify/add", params);
    return res;
}

// 编辑画像标签分类
export async function editTagClass(reqData, gameId) {
    const params = {
        game_id: gameId,
        id: reqData.id,
        name: reqData.name,
        describe: reqData.describe,
        type: reqData.type,
        use_type: reqData.useType.join()
    };
    const res = await ajax.post("/xiaoyue-operation/user_profile/tag_classify/update", params);
    return res;
}

// 删除画像标签分类
export async function delTagClass(reqData) {
    const params = {
        game_id: reqData.gameId,
        ids: reqData.ids
    };
    const res = await ajax.post("/xiaoyue-operation/user_profile/tag_classify/delete", params);
    return res;
}

// 画像标签分类列表
export async function queryTagClassList(reqData) {
    const params = {
        game_id: reqData.gameId
    };
    reqData.name ? (params.name = reqData.name) : null;
    const { count, list } = await ajax.get("/xiaoyue-operation/user_profile/tag_classify/list", params);
    const transList = list.map(item => {
        item.useType = item.use_type.split(",");
        return item;
    });
    return {
        count,
        list: transList
    };
}

// 添加画像标签
export async function addTag(reqData) {
    const params = {
        game_id: reqData.gameId,
        name: reqData.name,
        classify_id: reqData.classifyId,
        param_ids: convertParamIds(reqData.paramJson),
        param_json: convertParamJson(reqData.paramJson),
        describe: reqData.describe
    };
    try {
        const res = await ajax.post("/xiaoyue-operation/user_profile/tag/add", params);
        return res;
    } catch (error) {
        MessageBox.confirm(error.response.data.err_msg, "错误", { 
            showConfirmButton: false,
            showCancelButton: false,
            type: "warning"
        });
        throw new Error(error)
    }
}

function convertParamIds(data = []) {
    const res = [];
    data.forEach(item => {
        res.push(item.value.param.value)
    });
    return res.join();
}

// 参数条件转后端格式
function convertParamJson(data = []) {
    const res = [];
    data.forEach(item => {
        const param = {
            param_id: item.value.param.value,
            condition: item.value.op,
            value: item.value.val instanceof Array ? item.value.val.join() : item.value.val.toString(),
        };
        res.push(param)
    });
    return JSON.stringify(res);
}

// 编辑画像标签
export async function editTag(reqData) {
    const params = {
        game_id: reqData.gameId,
        id: reqData.id,
        name: reqData.name,
        classify_id: reqData.classifyId,
        param_ids: convertParamIds(reqData.paramJson),
        param_json: convertParamJson(reqData.paramJson),
        describe: reqData.describe
    };
    const res = await ajax.post("/xiaoyue-operation/user_profile/tag/update", params);
    return res;
}

// 批量删除画像标签
export async function delTag(reqData) {
    const params = {
        game_id: reqData.gameId,
        ids: reqData.ids
    };
    const res = await ajax.post("/xiaoyue-operation/user_profile/tag/delete", params);
    return res;
}

export function transitionText(data = []) {
    let resTxt = "";
    data.forEach((item, index) => {
        resTxt = resTxt.concat(`${item.param_id} ${item.condition} ${item.value} ${index !== data.length - 1 ? "AND" : ""} `);
    });
    return resTxt;
}

function getOperationBtn(status) {
    return [
        {
            label: "复制为新标签",
            value: "cope"
        },
        {
            label: status ? "停用" : "启用",
            value: status ? "off" : "on"
        },
        {
            label: "删除",
            value: "del"
        }
    ];
}

// 获取画像标签列表
export async function queryTagList(reqData) {
    const params = {
        game_id: reqData.gameId,
        page: reqData.page || 1,
        size: reqData.size || 10
    };
    reqData.currentClassId && (params.classify_id = reqData.currentClassId);
    if (reqData.params && reqData.params.length > 0) {
        params.param_ids = reqData.params.join();
    }
    if (reqData.status && reqData.status !== "") {
        params.status = reqData.status;
    }
    if (reqData.keyWordSearch && reqData.keyWordSearch.keyWord) {
        params.search_type = reqData.keyWordSearch.type;
        params.search_field = reqData.keyWordSearch.keyWord;
    }
    const { count, enable_count: enableCount, not_enable_count: noEnableCount, list = [] } = await ajax.get("/xiaoyue-operation/user_profile/tag/search", params);
    return {
        count,
        enableCount,
        noEnableCount,
        list: list.map(item => {
            return {
                ...item,
                status: {
                    text: item.status ? "● 已启用" : "● 未启用",
                    color: item.status ? "#00cd68" : "#7a7f8f"
                },
                operation: getOperationBtn(item.status)
            }
        })
    }
}

// 获取参数组列表
export async function getConditionLVList(gameId) {
    const { list } = await ajax.get("/xiaoyue-operation/user_profile/param/search", { game_id: gameId });
    return list.map(item => ({
        label: item.name,
        value: {
            value: item.id.toString(),
            valType: item.type, //第三个组件类型
            options: item.options, // 这个可能自带的选项
            // param: item.param, // ?
            // type: item.type,
        }
    }));
}

// 获取数据类型对应的操作符列表
export async function getOperateList(reqData) {
    const result = await ajax.get("/xiaoyue-operation/user_profile/tag/getOperateList", { game_id: reqData.gameId });
    return result;
}

// 获取节点详情
// 初始值， 第一个select的下拉项
export async function getConditionNodeDetail(paramJson, params) {
    const conditionGroups = [
        {
            content: paramJson,
        }
    ];
    const { groups } = convertConditionsFromServer(conditionGroups, params);
    return {
        groups,
    };
}

function convertConditionsFromServer(conditionGroups, params) {
    const groups = [];
    const doCircle = (node, level) => {
        let connector = "";
        if (level === 1) {
            connector = "AND";
        }
        const children = [];
        (node.child_group || []).forEach(child => {
            children.push(doCircle(child, level + 1));
        });
        let value = null;
        if (level === 2) {
            const foundParam = params.find(p => p.value.value == node.param_id);
            value = {
                param: foundParam ? foundParam.value : "",
                op: node.condition,
                val: node.value
            };
            if (foundParam.value.valType === "datetime") {
                if (node.condition === "bet" || node.condition === "nbet") {
                    // 时间段 str转arr
                    value.val = node.value.split(",");
                }
            }
            if (foundParam.value.valType === "bool") {
                // bool类型 str转boolean
                value.val = node.value === "true" ? true : false;
            }
        }
        return {
            uId: uniqueId(),
            type: ["Group", "Group", "Condition"][level],
            connector: connector || "",
            level,
            children,
            value,
        };
    };
    conditionGroups.forEach(cg => {
        cg.child_group = JSON.parse(cg.content);
        groups.push({
            updateState: "",
            groupName: "",
            groupId: "",
            conditions: doCircle(cg, 1),
        });
    });
    return {
        groups,
    };
}

// 批量设置画像标签启用状态
export async function changeStatusTag(reqData) {
    const params = {
        game_id: reqData.gameId,
        ids: reqData.ids,
        status: reqData.status
    };
    const res = await ajax.post("/xiaoyue-operation/user_profile/tag/changeStatus", params);
    return res;
}
